var _a;
import { __makeTemplateObject } from "tslib";
import { css } from 'styled-components';
export var Events = {
    ADD: 'add',
    REMOVE: 'remove',
};
export var Types = {
    SUCCESS: 'success',
    WARN: 'warn',
    INFO: 'info',
    ERROR: 'error',
};
export var Positions = {
    TOP_LEFT: 'top-left',
    TOP_CENTER: 'top-center',
    TOP_RIGHT: 'top-right',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_CENTER: 'bottom-center',
    BOTTOM_RIGHT: 'bottom-right',
};
export var PositionConfigs = (_a = {},
    _a[Positions.TOP_LEFT] = {
        animationIn: 'slideInLeft',
        animationOut: 'fadeOutUp',
        wrapperStyle: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position: fixed;\n      left: 1rem;\n      top: 1rem;\n    "], ["\n      position: fixed;\n      left: 1rem;\n      top: 1rem;\n    "]))),
    },
    _a[Positions.TOP_CENTER] = {
        animationIn: 'slideInDown',
        animationOut: 'fadeOutUp',
        wrapperStyle: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      position: fixed;\n      left: 50%;\n      transform: translateX(-50%);\n      top: 1rem;\n    "], ["\n      position: fixed;\n      left: 50%;\n      transform: translateX(-50%);\n      top: 1rem;\n    "]))),
    },
    _a[Positions.TOP_RIGHT] = {
        animationIn: 'slideInRight',
        animationOut: 'fadeOutUp',
        wrapperStyle: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      position: fixed;\n      right: 1rem;\n      top: 1rem;\n    "], ["\n      position: fixed;\n      right: 1rem;\n      top: 1rem;\n    "]))),
    },
    _a[Positions.BOTTOM_LEFT] = {
        animationIn: 'slideInLeft',
        animationOut: 'fadeOutDown',
        wrapperStyle: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      position: fixed;\n      left: 1rem;\n      bottom: 1rem;\n    "], ["\n      position: fixed;\n      left: 1rem;\n      bottom: 1rem;\n    "]))),
    },
    _a[Positions.BOTTOM_CENTER] = {
        animationIn: 'slideInUp',
        animationOut: 'fadeOutDown',
        wrapperStyle: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      position: fixed;\n      left: 50%;\n      transform: translateX(-50%);\n      border-bottom-color: 1rem;\n    "], ["\n      position: fixed;\n      left: 50%;\n      transform: translateX(-50%);\n      border-bottom-color: 1rem;\n    "]))),
    },
    _a[Positions.BOTTOM_RIGHT] = {
        animationIn: 'slideInLeft',
        animationOut: 'fadeOutDown',
        wrapperStyle: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      position: fixed;\n      right: 1rem;\n      bottom: 1rem;\n    "], ["\n      position: fixed;\n      right: 1rem;\n      bottom: 1rem;\n    "]))),
    },
    _a);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=config.js.map